import { useGetWbsCodeQuery, useGetСostCenterQuery } from '~/api/v2/hooks';

interface UseWbsOrCostCenterParams {
  wbsCodeId?: number | null;
  costCenterId?: number | null;
}

const useWbsOrCostCenter = ({ wbsCodeId, costCenterId }: UseWbsOrCostCenterParams) => {
  const { data: wbsCode } = useGetWbsCodeQuery({ id: wbsCodeId || 0 }, { skip: !wbsCodeId });
  const { data: costCenter } = useGetСostCenterQuery({ id: costCenterId || 0 }, { skip: !costCenterId });

  const displayValue = wbsCodeId ? wbsCode?.wbs_element_displ_id : costCenterId ? costCenter?.cost_center_id : '—';

  return { displayValue };
};

export default useWbsOrCostCenter;
